import type { ReactNode } from "react";

import { useId } from "react";

import { Typo } from "../../Typo";

export type FilterFieldControlProps = {
  "aria-labelledby"?: string;
  "aria-describedby"?: string;
};

export const FilterField = ({
  label,
  hint,
  children,
  "data-testid": testId,
}: {
  label?: string;
  hint?: string;
  children: ReactNode | ((controlProps: FilterFieldControlProps) => ReactNode);
  "data-testid"?: string;
}) => {
  const labelId = useId();
  const hintId = useId();

  return (
    <div className="flex flex-col gap-1" data-testid={testId}>
      {label && (
        <Typo
          element="span"
          type="labelSM"
          textColor="text-text-primary"
          id={labelId}
        >
          {label}
        </Typo>
      )}
      {hint && (
        <Typo
          element="p"
          type="bodyXS"
          textColor="text-text-secondary"
          className="mb-1"
          id={hintId}
        >
          {hint}
        </Typo>
      )}
      {typeof children === "function"
        ? children({
            "aria-labelledby": label ? labelId : undefined,
            "aria-describedby": hint ? hintId : undefined,
          })
        : children}
    </div>
  );
};
